/**
 * Per-visitor identity. The user id is a stable random id persisted in
 * localStorage (the legacy app used a cookie); the group id comes from the
 * `?id=` query param; the attendant name is optional and remembered.
 */

const USER_ID_KEY = "user_id";
const NAME_KEY = "attend_name";

export function getUserId(): string {
  let id = localStorage.getItem(USER_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(USER_ID_KEY, id);
  }
  return id;
}

export function getGroupId(): string | null {
  return new URLSearchParams(window.location.search).get("id");
}

export function isAdmin(): boolean {
  return new URLSearchParams(window.location.search).get("admin") !== null;
}

export function getAttendantName(): string | null {
  return localStorage.getItem(NAME_KEY);
}

export function setAttendantName(name: string): void {
  localStorage.setItem(NAME_KEY, name);
}
